import React from "react";
import SvgIcon from "../../../../parts/SvgIcon";
const weekDays = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
const TasksEverydayCkeck = ({ task, state, setState }) => {
  const [checked, setChecked] = React.useState(false);

  const isntEverydayChecked = () => Object.values(state[task]).includes(false);

  const handleEverydayCheck = () => {
    const obj = {};
    weekDays.forEach((day) => (obj[day] = isntEverydayChecked(state)));
    setState((prevState) => {
      return Object.assign({}, prevState, {
        [task]: obj,
      });
    });
  };
  React.useEffect(() => {
    if (isntEverydayChecked(state)) setChecked(false);
    else setChecked(true);
  }, [state[task]]);
  return (
    <>
      {/*  code for desktop */}
      <div className="Tasks-Day-Item force-mobile-hidden">
        <SvgIcon
          alt="checked"
          src={`/img/new-icons/vuesax-linear-tick-circle${
            checked ? "-gradient" : ""
          }.svg`}
          onClick={handleEverydayCheck}
          noFilterOnLight={checked ? true : undefined}
        />
      </div>
      {/*  code for mobile */}
      <div className="Tasks-Day-Item force-only-show-mobile">
        <SvgIcon
          alt="checked"
          src={
            checked
              ? "/img/new-icons/tick-circle.svg"
              : "/img/new-icons/vuesax-linear-tick-circle.svg"
          }
          onClick={handleEverydayCheck}
          noFilterOnLight={true}
        />
        <p className="p6">Everyday</p>
      </div>
    </>
  );
};

export default TasksEverydayCkeck;
